import './i18n';

import './App.css';
import Navbar from './Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Profile from './pages/settings/Profile';
import Devices from './pages/settings/Devices';
import DeviceTypes from './pages/settings/DeviceTypes';
import Permissions from './pages/settings/Permissions';
import Companies from './pages/settings/Companies';
import Images from './pages/Images';
import ImageUpload from './pages/ImageUpload';
import ImageList from './pages/images/ImageList';
import DeviceDetail from './pages/settings/DeviceDetail';
import IotDevices from './pages/settings/IotDevices';
import Logs from './pages/Logs';
import DeviceLogs from './pages/logs/DeviceLogs';
import logo from './logo.jpg';
import Footer from './Footer';

import { Container, Box } from '@mui/material';

import amplifyConfig from './aws-exports';
import { Amplify } from 'aws-amplify';
import { Authenticator, Image, ThemeProvider, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { DeviceDataProvider } from './context/DeviceDataContext';
import { useTranslation } from 'react-i18next';

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    Cognito: {
      userPoolClientId: amplifyConfig.cognito.APP_CLIENT_ID,
      userPoolId: amplifyConfig.cognito.USER_POOL_ID,
      identityPoolId: amplifyConfig.cognito.IDENTITY_POOL_ID,
      region: amplifyConfig.cognito.REGION,
      loginWith: {
        oauth: {
          domain: 'gtms-dev.auth.eu-central-1.amazoncognito.com',
          scopes: ['openid', 'email' ],
          redirectSignIn: ['https://mars.tryout.gtms-control.rocks/'],
          redirectSignOut: ['https://mars.tryout.gtms-control.rocks/'],
          responseType: 'code',
        },
        username: 'true',
        email: 'true',
        phone: 'false',
      }
    }
  },
  API: {
    REST: {
      gtms4: {
        endpoint: amplifyConfig.api.ENDPOINT,
        region: amplifyConfig.api.REGION
      }
    }
  },
  Storage: {
    // https://docs.amplify.aws/react/build-a-backend/storage/use-with-custom-s3/
    S3: {
      bucket: amplifyConfig.s3_upload.BUCKET,
      region: amplifyConfig.s3_upload.REGION,

      buckets: {
        upload: {
          bucketName: amplifyConfig.s3_upload.BUCKET,
          region: amplifyConfig.s3_upload.REGION,
        },
        static: {
          bucketName: amplifyConfig.s3_static.BUCKET,
          region: amplifyConfig.s3_static.REGION,
        }

      }
    }
  },
  Geo: {
    LocationService: {
      maps: {
        items: {
          [amplifyConfig.map.NAME]: { }
        },
        default: amplifyConfig.map.NAME
      },
      region: amplifyConfig.cognito.REGION
    }
  }
});


const amplifyTheme = {
  name: 'custom-theme',
  tokens: {
    components: {
      button: {
        primary: {
          backgroundColor: { value: '#c3352aff' },
          color: { value: 'white' },
        },
      },
    },
  },
};

const loginComponents = {
  Header() {
    const { t } = useTranslation();
    const urlParams = new URLSearchParams(window.location.search);
    const hasAuthCode = urlParams.has('code');

    return (
      <Box sx={{ textAlign: 'center', padding: 'large', mt: '20vh' }}>
        <Image
          src={logo}
          style={{ maxWidth: 3000, width: '100%' }}
        />
        {hasAuthCode && (
          <Box sx={{
            mt: 2,
            p: 2,
            backgroundColor: '#d1ecf1',
            border: '1px solid #bee5eb',
            borderRadius: '4px',
            color: '#0c5460'
          }}>
            <strong>{t('auth.processingLogin')}</strong><br/>
            {t('auth.pleaseWait')}
          </Box>
        )}
      </Box>
    );
  },
  SignIn: {
    Footer() {
      const { t } = useTranslation();
      const { toForgotPassword } = useAuthenticator
      return (
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <button
            style={{
              background: 'none',
              border: 'none',
              color: '#000000ff',
              cursor: 'pointer',
              fontSize: '0.9rem',
              padding: 0,
            }}
            onClick={toForgotPassword}
          >
            {t('auth.resetPassword')}
          </button>
        </Box>
      );
    },
  },
}


function App() {
  return (
    <ThemeProvider theme={amplifyTheme}>
      <Authenticator components={loginComponents} hideSignUp>
        {({ signOut, user }) => (
          <DeviceDataProvider>
            <Container maxWidth="xl" disableGutters sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <BrowserRouter>
                <Navbar signOut={signOut} user={user} />
                <Box sx={{ flexGrow: 1 }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/settings/*" element={<Settings />}>
                      <Route path="profile" element={<Profile />} />
                      <Route path="devices" element={<Devices />} />
                      <Route path="devices/:id" element={<DeviceDetail />} />
                      <Route path="device-types" element={<DeviceTypes />} />
                      <Route path="users" element={<Permissions />} />
                      <Route path="companies" element={<Companies />} />
                      <Route path="iot-devices" element={<IotDevices />} />
                      <Route index element={<Profile />} />
                    </Route>
                    <Route path="/images/*" element={<Images />}>
                      <Route path="list" element={<ImageList />} />
                      <Route path="upload" element={<ImageUpload />} />
                      <Route index element={<ImageList />} />
                    </Route>
                    <Route path="/logs/*" element={<Logs />}>
                      <Route path=":deviceId" element={<DeviceLogs />} />
                      <Route index element={<DeviceLogs />} />
                    </Route>
                  </Routes>
                </Box>
                <Footer />
              </BrowserRouter>
            </Container>
          </DeviceDataProvider>
        )}
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
